import { trackConfig, type IFramework } from '@/framework';
import { LayerType, VectorType, type ILayerProps, type IVectorLayerProps } from '@/version-types';
import { pushHistory, requestVectorSVGPreview, updateLayer } from '../utils';

export interface IBlur {
    /**
     * 设置模糊特
     * @param layerID - 图层 id
     * @param value - 模糊程度
     * @param options - 可选；配置项；`options.writeHistory` - 是否写入历史记录
     */
    setBlur(layerID: string, value: number, options?: { writeHistory: boolean }): ILayerProps | void;
}

export class Blur implements IBlur {
    private prevLayer: ILayerProps | null = null;

    constructor(private framework: IFramework) {}

    setBlur(layerID: string, value: number, options = { writeHistory: false }) {
        const prevLayer = (() => {
            if (this.prevLayer?.id === layerID) return this.prevLayer;
            this.prevLayer = this.framework.service.flatLayer.getLayer(layerID, true);
            return this.prevLayer;
        })();

        if (!prevLayer || prevLayer.layerType !== LayerType.VECTOR_LAYER) return;

        const prevLayerData = prevLayer.data as IVectorLayerProps;
        const { vectorType } = prevLayerData;

        // Graph 类型不支持模糊调节
        if (vectorType === VectorType.Graph) return;

        const { writeHistory } = options;

        if (writeHistory) {
            const nextLayer = this.framework.service.flatLayer.getLayer(layerID, true);

            requestVectorSVGPreview(this.framework, 'commit', nextLayer);
            updateLayer(this.framework, nextLayer);

            pushHistory(this.framework, prevLayer, nextLayer, trackConfig[LayerType.VECTOR_LAYER].blur);
            this.prevLayer = null;

            return nextLayer;
        }

        const nextLayerData: IVectorLayerProps = { ...prevLayerData, blur: value };
        const nextLayer: ILayerProps = { ...prevLayer, data: nextLayerData };

        requestVectorSVGPreview(this.framework, 'update', nextLayer);
        updateLayer(this.framework, nextLayer, { dataOnly: true });

        return nextLayer;
    }
}
